import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {propTypes, defaultProps} from 'react-props-decorators';
import _ from 'lodash';

import './page-header.less';

@propTypes({
    title: PropTypes.string,
    actions: PropTypes.array,
    contents: PropTypes.array,
})

export default class PageHeader extends Component {

    logoImageCondition() {
       /* if (window.RNIS_SETTINGS.CITY_OMSK) {
            return '/static/img/logo_portal_omsk.png';
        }
        if (window.RNIS_SETTINGS.CITY_MURMANSK) {
            return '/static/img/logo_portal_murmansk.png';
        }
        return '/static/img/logo_portal_moscow.png';*/
        return window.RNIS_SETTINGS.LOGOIMAGE
    }

    render() {
        let list = [];

        _.each(this.props.contents, (content, i) => {
            list.push(
                <li className="top-menu__item" key={`content${i}`}>
                    {content}
                </li>
            );
        });
        if (this.props.contents && this.props.actions && this.props.contents.length && this.props.actions.length) {
            list.push(
                <li className="top-menu__item" key="separator">
                    <div className="top-menu__separator"></div>
                </li>
            );
        }
        _.each(this.props.actions, (action, i) => {
            list.push(
                <li className="top-menu__item" key={`action${i}`}>
                    {action}
                </li>
            );
        });



        return (
            <div className="header header_fixed clearAfter">
                {window.RNIS_SETTINGS.LOGOIMAGE ? (
                <div className="header__logonobg">
                    <img src={this.logoImageCondition()} alt="logo" />
                    <span className="header__logo-txt">
                        {window.RNIS_SETTINGS.TITLE}
                    </span>
                </div>
             ) : (
                <div className="header__logo">
                    <span className="header__logo-txt">
                        {window.RNIS_SETTINGS.TITLE}
                    </span>
                </div>) }
                <div className="header__title">
                    {this.props.title}
                </div>
                <div className="top-menu clearAfter">
                    <ul className="top-menu__list">
                        {list}
                    </ul>
                </div>
            </div>
        )
    }

}


@propTypes({
    text: PropTypes.string,
    icon: PropTypes.string
})

export class PageHeaderButton extends Component {
    render() {
        const Icon = this.props.icon
            ? (<i className={['icon', 'icon-' + this.props.icon, 'icon-16'].join(' ')}/> )
            : '';

        const Text = this.props.text
            ? <div className="text">{this.props.text}</div>
            : '';

        return (
            <div className="page-header-button">
                {Icon}
                {Text}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ui/page-header.js